import { render, staticRenderFns } from "./WorkOrderRecords.vue?vue&type=template&id=2515318b&scoped=true"
import script from "./WorkOrderRecords.vue?vue&type=script&lang=js"
export * from "./WorkOrderRecords.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderRecords.vue?vue&type=style&index=0&id=2515318b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2515318b",
  null
  
)

export default component.exports